export { default as RecepcionIngreso } from "./RecepcionIngreso";

